import moment from 'moment';

export const callString = `{
  uuid,
  area_id,
  group_id,
  screen_id,
  expected_end_at,
  ra_number,
  start_at,
  trip_type,
  end_at,
  rider_email,
  error,
  success
}`;

export const screenCallString = `{
  uuid,
  session_status
  error,
  success
}`;

export var sdate = moment('1.1.1970').format('X');
export var edate = moment().format('X');

export const filterParams = ['group_id', 'trip_type', 'screen_id'];

export const screenFilterParams = ['session_status'];
